import * as reducer from './savePoint.reducer'

export const initialState = reducer.initialState
export const actionsMap = reducer.actionsMap
